/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface Result
 */
export interface Result {
    /**
     * 
     * @type {ResultStates}
     * @memberof Result
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof Result
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof Result
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof Result
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Result
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Result
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof Result
     */
    validationErrors: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the Result interface.
 */
export function instanceOfResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;

    return isInstance;
}

export function ResultFromJSON(json: any): Result {
    return ResultFromJSONTyped(json, false);
}

export function ResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): Result {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
    };
}

export function ResultToJSON(value?: Result | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
    };
}

